@import '@styles/fonts.scss';
@import '@styles/colors.scss';

// Liftable spec: canvas 02 (.rel/.rel-h/.rel-grid/.rel-card) + canvas 06 §11 breakpoints.

.rel {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 8px 64px 40px;
    box-sizing: border-box;

    @media (max-width: 900px) {
        padding: 8px 32px 32px;
    }

    @media (max-width: 600px) {
        padding: 4px 20px 28px;
    }
}

.relHead {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    margin: 0 0 16px;
}

.relTitle {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 500;
    font-size: 22px;
    color: var(--text);
    margin: 0;
}

.relLink {
    font-family: var(--font-mono);
    font-size: 11px;
    letter-spacing: 0.06em;
    color: var(--yolk);
    white-space: nowrap;

    &:hover { color: var(--yolk-hover); }
    &:focus-visible { outline: 2px solid var(--yolk); outline-offset: 2px; border-radius: 4px; }
}

.relGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;

    @media (max-width: 1023px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 639px) {
        grid-template-columns: none;
        grid-auto-flow: column;
        grid-auto-columns: 66vw;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        padding-bottom: 4px;
        -webkit-overflow-scrolling: touch;
    }
}

.relCard {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg, 14px);
    overflow: hidden;
    background: var(--surface);
    transition: border-color 150ms ease;

    &:hover { border-color: var(--border-med); }

    @media (max-width: 639px) {
        scroll-snap-align: start;
    }
}

// The card's own link (image + title + meta) — was .relCard itself before the "Wear this →"
// affordance (invitation 2, spine réclame Wave 1) split the card into two separately-targeted
// links (one to `/{slug}`, one to `/{slug}?autogenerate=1`); .relCard is now the plain <div>
// wrapper, this is the focusable/clickable child.
.relCardLink {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;

    &:focus-visible { outline: 2px solid var(--yolk); outline-offset: -2px; }
}

// "Wear this →" — invitation 2 (spine réclame Wave 1). Only rendered for showWearAction (D-del).
.relCardWear {
    display: block;
    padding: 0 12px 12px;
    margin-top: -6px;
    font-family: var(--font-mono);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--yolk);
    text-decoration: none;

    &:hover { color: var(--yolk-hover); }
    &:focus-visible { outline: 2px solid var(--yolk); outline-offset: 2px; border-radius: 4px; }
}

.relCardPh {
    display: block;
    // §14 crop rule (canvas 06 revision, 2026-07-24): 3/4 is the native ratio of every generated
    // portrait — matching the source means no crop at all, so no cover can crop badly. Any other
    // ratio (this was 4/3) crops arbitrarily and the failure depends on the photo.
    aspect-ratio: 3 / 4;
    background: var(--bg);
}

.relCardImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    // §14 safety net: for the rare non-3:4 cover source, eat the floor, never the face. Never
    // 50% 50% on a portrait.
    object-position: 50% 22%;
    display: block;
}

.relCardTitle {
    display: block;
    padding: 10px 12px 12px;
    font-family: var(--font-body);
    font-size: 13px;
    font-weight: 600;
    color: var(--text);
}

.relCardMeta {
    display: block;
    font-style: normal;
    font-family: var(--font-mono);
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.04em;
    color: var(--text-dim);
    margin-top: 3px;
}
